<template>
  <div>
    <div class="d-none d-lg-block">
      <div class="nav flex-column h5 font-weight-normal mb-0">
        <div
          v-for="item in items"
          v-bind:key="item.link"
          class="nav-item mb-1"
        >
          <a
            :href="item.link"
            :class="['nav-link text-body text-decoration-none', {'font-weight-bold': item.active}]"
          >
            {{ item.name }}
          </a>
        </div>
      </div>
    </div>
    <div class="list-group">
      <a
        v-for="item in items"
        :href="item.link"
        :class="['list-group-item list-group-item-action text-body', {'font-weight-bold': item.active}]"
      >
        {{ item.name }}
      </a>
    </div>
  </div>
</template>

<style type="scss" scoped>

</style>

<script>
import { find, filter } from 'lodash'

export default {
  props: {
    title: {
      type: String
    },
    items: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    active () {
      return find(this.items, (item) => {
        return item.active
      })
    },
    inactiveItems () {
      return filter(this.items, (item) => {
        return !item.active
      })
    }
  }
}
</script>